import { isAfter, parseISO } from 'date-fns';

export function isAccessTokenExpired(expires_at: Date | string) {
  const now = new Date();
  const refReshExpiresIn = parseISO(expires_at);
  const refreshTimestamp = refReshExpiresIn?.getTime();

  // show the dates
  // console.log('currentDate', now.toISOString());
  // console.log('token_expires_in', refReshExpiresIn);

  return isAfter(now, refreshTimestamp);
}
